import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import "./Pagination.css";
import IoIosArrowRoundBack from "../../../../assets/images/IoIosArrowRoundBack.svg"
import nextgrey from "../../../../assets/images/ArrowRightgrey.svg";
import TextField from "../TextField/TextField";
import { useSelector } from "react-redux";
import { PROJECT_TYPE } from "../../../../constants/constant";
import backwhite from "../../../../assets/images/backwhite.svg";
import nextwhite from "../../../../assets/images/ArrowRightWhite.svg"
import blueback from "../../../../assets/images/blueBack.svg"
import nextblue from "../../../../assets/images/ArrowRight.svg"

const List = styled("ul")({
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  alignItems: "center",
  columnGap: 4,
});

const Pagination = React.memo(({ items = [], handlePagination, pageValue, setPageValue, data, selectedPage, setSelectedPage,activeTab }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredNext, setIsHoveredNext] = useState(false);

  const itemCount = useSelector((state) => {
    if (activeTab === PROJECT_TYPE.PROJECT) {
      return state?.product?.totalProjects;
    } else {
      return state?.product?.archiveProjects;
    }
  });
  function handleInputChange(event) {
    const pageOffset = event.target.value;
    if (pageOffset <= items.length - 2) {
      setSelectedPage(pageOffset ? pageOffset : 1);
      // handlePagination(pageOffset);
      setPageValue(pageOffset);
    }
  }
  console.log("datadata", data.length);
  let pageOfResult = null; // Initialize result variable outside of the if block
  const pageCalc = items[0]?.page;
  if (typeof pageCalc === "number" && !isNaN(pageCalc)) {
    pageOfResult = pageCalc * 10 + 1; // Assign the value to result
  }
  let pageEndOFResult = null;
  // const itemCount = data?.count;
  if (typeof pageCalc === "number" && !isNaN(pageCalc) && typeof itemCount === "number" && !isNaN(itemCount)) {
    pageEndOFResult = Math.min((pageCalc + 1) * 10, itemCount); // Assign the value to result
  }
   // Check if we are on the first or last page
   const totalPages = Math.ceil(itemCount / 10); 
  const currentPage = selectedPage;
   const isPreviousDisabled = currentPage <= 1;
   const isNextDisabled = currentPage >= totalPages;
  return (
    <div className="d-flex justify-content-between w-100 align-items-center">
      <div className="left-pagination">
        <span className="d-flex align-items-center page-results">
          Showing <span className="page-count">{pageOfResult}</span> to <span className="page-count">{pageEndOFResult}</span> of{" "}
          <span className="page-count">{itemCount}</span> results
        </span>
      </div>
      <nav className="d-flex align-items-center gap-3">
        <List>
          {items?.map(({ page, type, selected, ...item }, index) => {
            let children = null;

            if (type === "start-ellipsis" || type === "end-ellipsis") {
              children = "…";
            } else if (type === "page") {
              children = (
                <Button
                  key={index}
                  type="button"
                  className="pagination__page"
                  variant="contained"
                  style={{
                    background: selectedPage === page ? "4F46E5" : "transparent",
                    color: selectedPage === page ? "#fff" : "#25282B",
                  }}
                  {...item}
                >
                  {page}
                </Button>
              );
            } else if (type === "previous") {
              children = (
                <Button
                  variant="outlined"
                  className="pagination__pagecontrol"
                  key={index}
                  type="button"
                  {...item}
                  onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              // disabled={isPreviousDisabled}
                >
                  <img src={isHovered && !isPreviousDisabled ? backwhite : (isPreviousDisabled ? IoIosArrowRoundBack : blueback)} alt="back" fontSize={24} />
                  <span className="d-md-none d-lg-block ml-[4px]">{type}</span>
                </Button>
              );
            } else if (type === "next") {
              children = (
                <Button variant="outlined" className="pagination__pagecontrol" key={index} type="button" {...item}  onMouseEnter={() => setIsHoveredNext(true)}
                onMouseLeave={() => setIsHoveredNext(false)}>
                  <span className="d-md-none d-lg-block">{type}</span> <img src={isHoveredNext && !isNextDisabled ? nextwhite : (isNextDisabled ? nextgrey : nextblue)} alt="next" fontSize={24} />
                </Button>
              );
            }
            return <li key={index}>{children}</li>;
          })}
        </List>
        <div className="pageInput">
          <label className="inputLabel">Go to</label>
          <TextField
            id="standard-basic"
            label=""
            className="form-control"
            autoComplete="off"
            placeholder="Number"
            value={pageValue}
            onChange={handleInputChange}
          />
        </div>
      </nav>
    </div>
  );
});

export default Pagination;
